import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Col, Form, Input, Row, Radio, Select, Pagination } from "antd";
import AWS from "aws-sdk";
import moment from "moment";

import memberApi from "../../../apis/MemberManage.api";
import togetherApi from "../../../apis/Together.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { plutusS3 } from "../../../utils/plutusS3";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const LonglifePushComponent = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [userList, setUserList] = useState([]);
  const [searchUserList, setSearchUserList] = useState([]);
  const [selectUserList, setSelectUserList] = useState([]);
  const [expertList, setExpertList] = useState([]);
  const [influencerObj, setInfluencerObj] = useState({});

  const [pushInfo, setPushInfo] = useState({
    push_type: 2,
    influencer_id: null,
    targetType: 0,
    targetList: [],
    is_reservation: false,
    title: null,
    body: null,
    url: null,
    img: null,
    img_url: null,
    reservation_date: null,
    reservationDateStr: null,
    time: null,
    timeStr: null,
  }); // 앱 푸시 내용 (제목,내용,URL,이미지)
  const [valid, setValid] = useState(false); // 필수값 체크

  const typeItems = [
    { label: "미션", value: 0 },
    // { label: "전문가", value: 1 },
    { label: "공지사항", value: 2 },
    { label: "이벤트", value: 3 },
    // { label: "시스템", value: 4 },
    // { label: "기타", value: 5 },
  ];
  const targetItems = [
    { label: "전체", value: 0 },
    { label: "전문가", value: 2 },
    { label: "사용자", value: 1 },
  ];
  const reservationStatusItems = [
    { label: "설정안함", value: false },
    { label: "설정함", value: true },
  ];

  const [checkedItem, setCheckedItem] = useState({});
  const [linkType, setLinkType] = useState({ label: "없음", value: 0 });

  useEffect(() => {
    readUserList();
    readExpertList();
  }, []);

  useEffect(() => {
    if (
      pushInfo.body &&
      pushInfo.body?.trim() &&
      (pushInfo.targetType === 1 ? selectUserList?.length > 0 : true) &&
      (pushInfo.targetType === 2 ? pushInfo.influencer_id : true) &&
      (pushInfo.is_reservation
        ? pushInfo.reservation_date &&
          pushInfo.time &&
          (moment().isSame(pushInfo.reservation_date, "day")
            ? moment().hour() <= pushInfo.time.hour() &&
              moment().minutes() < pushInfo.time.minutes()
            : true)
        : true)
    ) {
      setValid(true);
    } else if (valid) {
      setValid(false);
    }
  }, [pushInfo, selectUserList]);

  const readUserList = async () => {
    try {
      const param = { type: "totalByPush" };
      const res = await memberApi.readLonglifeUserList(param);
      if (res.code === 200) {
        const userLabelList = res.result.userList?.map((user) => {
          return {
            label: user.name + ` [${user.provider ?? "휴대폰"}]`,
            value: user.id,
            // provider: user.provider ?? "휴대폰",
            partners_id: user.partners_id,
          };
        });
        // console.log(res.result.userList);
        // console.log("userLabelList = ", userLabelList);
        setUserList(userLabelList);
        setSearchUserList(userLabelList);
      } else {
        alert(
          "당영앱 사용자 목록을 조회하는데 실패하였습니다. 다시 시도해주시길 바랍니다.",
        );
        throw res.msg;
      }
    } catch (e) {
      console.log("readUserList read error", e);
    }
  };

  const readExpertList = async () => {
    try {
      const param = {};
      const res = await memberApi.readLonglifeExpertList(param);
      if (res.code === 200) {
        const expertLabelList = res.result.expertList?.map((expert) => {
          return {
            label: expert.name,
            value: expert.channel_id,
            partners_id: expert.partners_id,
          };
        });
        setExpertList(expertLabelList);
      } else {
        alert(
          "당영앱 전문가 목록을 조회하는데 실패하였습니다. 다시 시도해주시길 바랍니다.",
        );
        throw res.msg;
      }
    } catch (e) {
      console.log("readExpertList read error", e);
    }
  };

  const sendPush = async () => {
    try {
      setIsLoading(true);
      let param = {
        push_type: pushInfo.push_type,
        target_type: pushInfo.targetType,
        title: pushInfo.title,
        body: pushInfo.body,
        url: pushInfo.url ?? convertContentToLink(),
        is_reservation: pushInfo.is_reservation,
      };
      // 대상 유형별 셋틸
      if (pushInfo.targetType === 1) {
        param["targetList"] = selectUserList;
      } else if (pushInfo.targetType === 2) {
        param["targetList"] = [pushInfo.influencer_id];
      }
      // 예약일 관련 정보 설정
      if (pushInfo.is_reservation) {
        const reservationStr =
          `${pushInfo.reservationDateStr}${pushInfo.timeStr}`
            .replaceAll("-", "")
            .replaceAll(":", "");
        param["reservationDateStr"] = reservationStr;
      }
      // 이미지 관련 정보 설정
      if (pushInfo.img) {
        param[
          "img_url"
        ] = `${process.env.REACT_APP_LONGLIFE_S3_HOST}/images/push/`;
      }
      const res = await memberApi.sendPushForLonglife(param);
      if (res.code === 200) {
        await s3Upload(pushInfo.img, res.result.id);
        alert("작성하신 내용으로 정삭적으로 발송되었습니다.");
        setPushInfo({
          push_type: 2,
          targetType: 0,
          targetList: [],
          is_reservation: false,
          title: null,
          body: null,
          url: null,
          img: null,
          img_url: null,
          reservation_date: null,
          reservationDateStr: null,
          time: null,
          timeStr: null,
        });
      } else if (res.code === 400) {
        alert(
          "선택하신 대상 전부 해당 알림 전송 여부를 거부처리 하였습니다.\n다른 대상을 선택해주시길 바랍니다.",
        );
        setPushInfo({
          push_type: 2,
          targetType: 0,
          targetList: [],
          is_reservation: false,
          title: null,
          body: null,
          url: null,
          img: null,
          img_url: null,
          reservation_date: null,
          reservationDateStr: null,
          time: null,
          timeStr: null,
        });
      } else {
        alert(
          "작성하신 내용으로 앱 푸시 전송에 실패하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
    } catch (e) {
      console.log("sendPush send error", e);
    }
    setIsLoading(false);
  };

  const s3Upload = async (file, pushId) => {
    let s3Path = `images/push/${pushId}.jpg`;
    let params = {
      Bucket: process.env.REACT_APP_S3_LONGLIFE_BUCKETNAME,
      Key: s3Path,
      Body: file,
    };
    let res = await plutusS3.putObject(params).promise();

    return res.success === true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPushInfo({ ...pushInfo, [name]: value });
  };

  /**
   * 선택불가한 예약날짜 설정
   * @param current
   * @returns {boolean}
   */
  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  /**
   * 클릭한 컨텐츠 link로 변환하기
   * linkType ==> 0 - 없음 | 1 - 소통글 | 2 - 클래스 | 3 - 공동구매 | 4 - 영양제 추천
   * 		1. 미션 페이지 이동
   * 		mission/{미션아이디}/{미션 제목}
   * 		2. 내건강 페이지 이동
   * 		health/pedometer/record
   * 		3. 소통글및 공지글 이동
   * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/community/{소통글 아이디}
   * 		4. 문의페이지 이동
   * 		inquiry/{문의글 아이디}
   * 		5. 영양제 추천 페이지 이동
   * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/recommend_nutrients/{추천 영양제 아이디}
   * 		6. 성분 페이지 이동
   * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/ingredient/{성분 카테고리 영문명}
   * 		7. 조합 페이지 이동
   * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/combination/{조합게시글 아이디}
   * 		8. 공동구매 페이지 이동
   * 		StoreGroupBuying/{컨텐츠 아이디}
   */
  const convertContentToLink = () => {
    let link = "";
    if (checkedItem.id) {
      // 3 소통글 및 공지글 이동
      if (linkType.value === 1) {
        link = `channelId/${checkedItem.channel_id}/influencerId/${checkedItem.influencer_id}/community/${checkedItem.id}`;
      }
      if (linkType.value === 2) {
        link = `mission/${checkedItem.id}/${checkedItem.head_copy}`;
      }
      if (linkType.value === 3) {
        link = `StoreGroupBuying/${checkedItem.id}`;
      }
      if (linkType.value === 4) {
        link = `channelId/${checkedItem.channel_id}/influencerId/${checkedItem.influencer_id}/recommend_nutrients/${checkedItem.id}`;
      }
      // setPushInfo({
      // 	...pushInfo,
      // 	url: link,
      // });
      console.log("convertContentToLink == ", link);
      return link;
    }
  };

  return (
    <>
      <ContentHeaderComponent title="당영앱 PUSH" />
      <Row justify="space-between" wrap={false} id={`call-purchase-body`}>
        <Col span={8}>
          <div
            className="product-register-wrap"
            style={{ marginTop: 21, marginRight: 12 }}
          >
            {/*대상 맟 유형 설정*/}
            <Row
              className="product-register-border-box send-sms-border-box"
              align="middle"
              wrap={false}
              style={{ borderBottom: 0 }}
            >
              <span className="product-register-box-title">대상/유형 설정</span>
            </Row>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{ padding: "25px 25px 40px", height: "fit-content" }}
            >
              <p style={{ marginBottom: "0.5rem" }}>유형</p>
              <Select
                // className="longlife-push-reservation-radio-wrap"
                options={typeItems}
                onChange={(value) => {
                  setPushInfo({ ...pushInfo, push_type: value });
                }}
                value={pushInfo.push_type}
                // optionType="button"
                style={{ marginBottom: "1rem", width: "11rem" }}
                disabled={pushInfo.targetType}
              />
              <p style={{ marginBottom: "0.5rem" }}>대상</p>
              <Radio.Group
                className="longlife-push-reservation-radio-wrap"
                options={targetItems}
                onChange={(e) => {
                  if (e.target.value !== 1) {
                    setSelectUserList([]);
                  }
                  if (e.target.value !== 2) {
                    setPushInfo({
                      ...pushInfo,
                      targetType: e.target.value,
                      influencer_id: null,
                    });
                  } else {
                    setPushInfo({ ...pushInfo, targetType: e.target.value });
                  }
                }}
                value={pushInfo.targetType}
                optionType="button"
                style={{ marginBottom: "1rem" }}
              />
              {pushInfo.targetType === 0 ? (
                <p className="warningText">알림받기를 허용한 기기 대상</p>
              ) : pushInfo.targetType === 1 ? (
                <Select
                  mode="multiple"
                  placeholder="사용자를 선택해주세요"
                  maxTagCount="responsive"
                  optionLabelProp="label"
                  options={userList}
                  filterOption={(search, option) =>
                    option.label.includes(search.trim())
                  }
                  onChange={(value) => setSelectUserList(value)}
                  style={{
                    width: "100%",
                  }}
                />
              ) : (
                <>
                  <p className="warningText">
                    선택하신 전문가로 회원가입한 대상
                  </p>
                  <Select
                    placeholder="전문가를 선택해주세요"
                    onChange={(value, option) => {
                      setPushInfo({ ...pushInfo, influencer_id: value });
                      setInfluencerObj(option);
                    }}
                    // onSelect={(labelValue, option) => {
                    // 	let currList = [...selectUserList, option];
                    // 	setSelectUserList(currList);
                    // }}
                    // onDeselect={(labelValue) => {
                    // 	let currList = [...selectUserList];
                    // 	const saveList = currList.filter(
                    // 		(selectUser) => selectUser.label !== labelValue
                    // 	);
                    // 	setSelectUserList(saveList);
                    // }}
                    style={{
                      width: "100%",
                    }}
                    options={expertList}
                  />
                </>
              )}
            </div>
            {/*예약 설정*/}
            {/*<Row*/}
            {/*	className="product-register-border-box send-sms-border-box"*/}
            {/*	justify="space-between"*/}
            {/*	align="middle"*/}
            {/*	wrap={false}*/}
            {/*	style={{ marginTop: 24, borderBottom: 0 }}*/}
            {/*>*/}
            {/*	<span className="product-register-box-title">예약 설정</span>*/}
            {/*	<Radio.Group*/}
            {/*		className="longlife-push-reservation-radio-wrap"*/}
            {/*		options={reservationStatusItems}*/}
            {/*		onChange={(e) => {*/}
            {/*			if (!e.target.value) {*/}
            {/*				setPushInfo({*/}
            {/*					...pushInfo,*/}
            {/*					is_reservation: e.target.value,*/}
            {/*					reservation_date: null,*/}
            {/*					reservationDateStr: null,*/}
            {/*					time: null,*/}
            {/*					timeStr: null,*/}
            {/*				});*/}
            {/*			} else {*/}
            {/*				setPushInfo({*/}
            {/*					...pushInfo,*/}
            {/*					is_reservation: e.target.value,*/}
            {/*				});*/}
            {/*			}*/}
            {/*		}}*/}
            {/*		value={pushInfo.is_reservation}*/}
            {/*		optionType="button"*/}
            {/*	/>*/}
            {/*</Row>*/}
            {/*<div*/}
            {/*	className={*/}
            {/*		"product-register-border-box " +*/}
            {/*		(!pushInfo.is_reservation ? "box-disabled" : "")*/}
            {/*	}*/}
            {/*	wrap={false}*/}
            {/*	style={{ padding: "25px 25px 40px", height: "fit-content" }}*/}
            {/*>*/}
            {/*	<Form.Item*/}
            {/*		className="longlife-push-form-wrap"*/}
            {/*		label="날짜"*/}
            {/*		labelAlign="left"*/}
            {/*		colon={false}*/}
            {/*		labelCol={{ span: 24 }}*/}
            {/*		wrapperCol={{ span: 24 }}*/}
            {/*	>*/}
            {/*		<Row gutter={8}>*/}
            {/*			<Col span={12}>*/}
            {/*				<DatePicker*/}
            {/*					disabledDate={disabledDate}*/}
            {/*					disabled={!pushInfo.is_reservation}*/}
            {/*					value={pushInfo.reservation_date}*/}
            {/*					onChange={(selectDate, dateStr) => {*/}
            {/*						setPushInfo({*/}
            {/*							...pushInfo,*/}
            {/*							reservation_date: selectDate,*/}
            {/*							reservationDateStr: dateStr,*/}
            {/*						});*/}
            {/*					}}*/}
            {/*				/>*/}
            {/*			</Col>*/}
            {/*			<Col span={12}>*/}
            {/*				<TimePicker*/}
            {/*					format="HH:mm"*/}
            {/*					minuteStep={5}*/}
            {/*					disabled={!pushInfo.is_reservation}*/}
            {/*					value={pushInfo.time}*/}
            {/*					showNow={false}*/}
            {/*					onChange={(selectTime, timeStr) => {*/}
            {/*						setPushInfo({*/}
            {/*							...pushInfo,*/}
            {/*							time: selectTime,*/}
            {/*							timeStr: timeStr,*/}
            {/*						});*/}
            {/*					}}*/}
            {/*				/>*/}
            {/*				<p className="errorText" style={{ height: 22 }}>*/}
            {/*					{pushInfo.reservation_date &&*/}
            {/*					pushInfo.time &&*/}
            {/*					moment().isSame(pushInfo.reservation_date, "day") &&*/}
            {/*					moment().hour() >= pushInfo.time.hour() &&*/}
            {/*					moment().minutes() >= pushInfo.time.minutes()*/}
            {/*						? "예약할 수 없는 시간입니다."*/}
            {/*						: ""}*/}
            {/*				</p>*/}
            {/*			</Col>*/}
            {/*		</Row>*/}
            {/*	</Form.Item>*/}
            {/*</div>*/}
          </div>
        </Col>
        <Col span={16}>
          <div
            className="product-register-wrap"
            style={{ marginTop: 21, marginLeft: 12, marginRight: 30 }}
          >
            <Row
              className="product-register-border-box send-sms-border-box"
              justify="space-between"
              align="middle"
              wrap={false}
              style={{ borderBottom: 0 }}
            >
              <span className="product-register-box-title">내용 작성</span>
              <Button disabled={!valid} loading={isLoading} onClick={sendPush}>
                전송
              </Button>
            </Row>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{ padding: "27px 20px 26px 27px", height: "fit-content" }}
            >
              {/*<Form.Item*/}
              {/*	className="longlife-push-form-wrap"*/}
              {/*	label="제목"*/}
              {/*	labelAlign="left"*/}
              {/*	colon={false}*/}
              {/*	labelCol={{ span: 24 }}*/}
              {/*	wrapperCol={{ span: 24 }}*/}
              {/*>*/}
              {/*	<Input*/}
              {/*		name="title"*/}
              {/*		value={pushInfo.title}*/}
              {/*		placeholder="제목을 입력해주세요 (선택)"*/}
              {/*		maxLength={100}*/}
              {/*		onChange={handleChange}*/}
              {/*	/>*/}
              {/*</Form.Item>*/}
              <Form.Item
                className="longlife-push-form-wrap"
                label="내용"
                labelAlign="left"
                required
                colon={false}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input.TextArea
                  name="body"
                  value={pushInfo.body}
                  placeholder="내용을 입력해주세요 (필수)"
                  maxLength={500}
                  onChange={handleChange}
                />
              </Form.Item>
              {/*<Form.Item*/}
              {/*	className="longlife-push-form-wrap"*/}
              {/*	label="이미지"*/}
              {/*	labelAlign="left"*/}
              {/*	colon={false}*/}
              {/*	labelCol={{ span: 4 }}*/}
              {/*	wrapperCol={{ span: 20 }}*/}
              {/*>*/}
              {/*	<Upload*/}
              {/*		listType="picture"*/}
              {/*		maxCount={1}*/}
              {/*		beforeUpload={(file) => false}*/}
              {/*		onChange={({ file }) => {*/}
              {/*			if (file?.status && file.status === "removed") {*/}
              {/*				setPushInfo({ ...pushInfo, img: null });*/}
              {/*			} else {*/}
              {/*				setPushInfo({ ...pushInfo, img: file });*/}
              {/*			}*/}
              {/*		}}*/}
              {/*		onPreview={handlePreview}*/}
              {/*	>*/}
              {/*		<Button>첨부이미지 업로드</Button>*/}
              {/*	</Upload>*/}
              {/*</Form.Item>*/}
              {/*<Form.Item*/}
              {/*	className="longlife-push-form-wrap"*/}
              {/*	label="URL"*/}
              {/*	labelAlign="left"*/}
              {/*	colon={false}*/}
              {/*	labelCol={{ span: 24 }}*/}
              {/*	wrapperCol={{ span: 24 }}*/}
              {/*>*/}
              {/*	<Input*/}
              {/*		name="url"*/}
              {/*		value={pushInfo.url}*/}
              {/*		placeholder="https://admin.dangyoung.com (선택)"*/}
              {/*		maxLength={300}*/}
              {/*		onChange={handleChange}*/}
              {/*	/>*/}
              {/*</Form.Item>*/}
              {/* 전문가에서 앱 푸시 보내기 */}
              {pushInfo?.targetType === 2 && (
                <LonglifePushLinkComponent
                  user={influencerObj}
                  checkedItem={checkedItem}
                  setCheckedItem={setCheckedItem}
                  linkType={linkType}
                  setLinkType={setLinkType}
                  convertContentToLink={convertContentToLink}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

const LonglifePushLinkComponent = ({
  user,
  checkedItem,
  setCheckedItem,
  linkType,
  setLinkType,
  convertContentToLink,
}) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const pageSize = 5;
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [contentList, setContentList] = useState([]);

  const linkTypeItems = [
    { label: "없음", value: 0 },
    { label: "소통글", value: 1 },
    { label: "클래스", value: 2 },
    { label: "공동구매", value: 3 },
    { label: "영양제 추천", value: 4 },
  ];

  useEffect(() => {
    setCheckedItem({});
    if (currentPageNumber !== 1) {
      setCurrentPageNumber(1);
    } else {
      getContentCategory();
    }
  }, [linkType]);

  useEffect(() => {
    getContentCategory();
  }, [user, currentPageNumber]);

  /**
   * 링크 정보 가져오기
   * @type {(function(): Promise<void>)|*}
   */
  const getContentCategory = useCallback(async () => {
    if (user?.partners_id) {
      setIsLoading(true);
      let param = {
        offset: (currentPageNumber - 1) * pageSize,
        pageSize: pageSize,
        categoryId: linkType.value,
        userId: user?.partners_id,
      };
      const res = await togetherApi.getContentsByCategory(param);
      if (res.code === 200) {
        // console.log(res.result);
        setTotalCount(res.result.totalCnt);
        setContentList(res.result?.contentDTOList);
      }
    }
    setIsLoading(false);
  }, [currentPageNumber, linkType, user]);

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    // const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
  };

  return (
    <Form.Item
      label="유입 링크"
      labelAlign="left"
      colon={false}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Select
            options={linkTypeItems}
            onChange={(value, option) => {
              setLinkType(option);
            }}
            value={linkType.label}
            style={{ marginBottom: "1rem", width: "11rem" }}
            disabled={isLoading}
          />
          {checkedItem.id && (
            <div
              style={{
                display: "flex",
                // cursor: "pointer",
                padding: "0.5em 1em",
                gap: "0.5em",
                border: "solid 1px #ced4da",
                borderRadius: "5px",
                alignItems: "center",
                maxWidth: "400px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  gap: "0.3em",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "1.1em",
                    lineHeight: 1,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {checkedItem.head_copy}
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.9em",
                    lineHeight: 1,
                    fontWeight: 400,
                    color: "#868e96",
                  }}
                >
                  {convertContentToLink()}
                </p>
              </div>
            </div>
          )}
        </div>
        {linkType.value !== 0 && (
          <>
            {contentList?.length ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1em",
                  padding: "1em 0",
                }}
              >
                {contentList?.map((item, idx) => {
                  const newContent = item.content
                    // ?.replaceAll(`<p>`, "")
                    // ?.replaceAll(`<p></p>`, "")
                    ?.replaceAll(`</p><p>`, "")
                    ?.replaceAll(`<br>`, "");
                  return (
                    <div
                      key={`content-list=${idx}`}
                      style={{
                        display: "flex",
                        cursor: "pointer",
                        padding: "1em",
                        gap: "0.5em",
                        border: "solid 1px #ced4da",
                        borderRadius: "5px",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCheckedItem(item);
                      }}
                    >
                      <img
                        src={`${
                          process.env.REACT_APP_HOST
                        }/assets/images/memberManage/${
                          item.id === checkedItem?.id ? "checkActive" : "check"
                        }.png`}
                        alt={`링크 체크`}
                        style={{
                          height: "1.2em",
                          width: "1.2em",
                        }}
                      />
                      <div
                        style={{
                          width: "calc(100% - 1.5em)",
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.5em",
                        }}
                      >
                        {item.head_copy && (
                          <p
                            style={{
                              margin: 0,
                              fontSize: "1.1em",
                              lineHeight: 1,
                              fontWeight: "600",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {item.head_copy}
                          </p>
                        )}
                        <p
                          style={{
                            margin: 0,
                            fontSize: "0.9em",
                            lineHeight: 1,
                            fontWeight: 400,
                            color: "#868e96",
                          }}
                        >
                          {moment(item.created_at).format("YYYY.MM.DD")}
                        </p>
                        {linkType.value !== 2 && newContent && (
                          <div className={`community-app-push-body-div`}>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: newContent,
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
                <Pagination
                  className="report-pagination-wrap"
                  showSizeChanger={false}
                  current={currentPageNumber}
                  pageSize={pageSize}
                  total={totalCount}
                  onChange={handleChangePagination}
                />
              </div>
            ) : (
              <Row
                align={"middle"}
                style={{
                  width: "100%",
                  flexDirection: "column",
                  padding: "5em 0",
                }}
              >
                <img
                  src={`/assets/images/warning.png`}
                  alt={`warning-icon`}
                  style={{
                    width: "3em",
                    height: "auto",
                  }}
                />
                <p
                  style={{
                    marginTop: "1em",
                    color: "#adb5bd",
                    fontSize: "1.1em",
                    fontWeight: 500,
                  }}
                >
                  작성글이 없습니다.
                </p>
              </Row>
            )}
          </>
        )}
      </div>
    </Form.Item>
  );
};
export default LonglifePushComponent;
